import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { BillingCycleEnum, type UsageLimit } from 'js/src/client';

const initialState: UsageLimit = {
    ai_vo_minutes_used_in_cycle: 0,
    ai_vo_minutes_limit_per_cycle: null,
    usage_cycle: BillingCycleEnum.MONTHLY,
    current_usage_cycle_start: '',
    current_usage_cycle_end: '',
    animation_seconds_used_in_cycle: 0,
    animation_seconds_limit_per_cycle: null,
    trial_animation_seconds_used: 0,
    trial_animation_seconds_limit: 0,
    translations_used_in_cycle: 0,
    translations_limit_per_cycle: null,
    marketplace_credits_used_in_cycle: 0,
    marketplace_credits_limit_per_cycle: null,
    image_generations_used_in_cycle: 0,
    image_generations_limit_per_cycle: null,
    addon_animation_minutes_quantity: 0,
};

export const usageLimitSlice = createSlice({
    name: 'usageLimit',
    initialState,
    reducers: {
        setUsageLimit: (state, action: PayloadAction<UsageLimit>) => {
            state.ai_vo_minutes_used_in_cycle = action.payload.ai_vo_minutes_used_in_cycle;
            state.ai_vo_minutes_limit_per_cycle = action.payload.ai_vo_minutes_limit_per_cycle;
            state.usage_cycle = action.payload.usage_cycle;
            state.current_usage_cycle_start = action.payload.current_usage_cycle_start;
            state.current_usage_cycle_end = action.payload.current_usage_cycle_end;
            state.animation_seconds_used_in_cycle = action.payload.animation_seconds_used_in_cycle;
            state.animation_seconds_limit_per_cycle =
                action.payload.animation_seconds_limit_per_cycle;
            state.trial_animation_seconds_used = action.payload.trial_animation_seconds_used;
            state.trial_animation_seconds_limit = action.payload.trial_animation_seconds_limit;
            state.translations_used_in_cycle = action.payload.translations_used_in_cycle;
            state.translations_limit_per_cycle = action.payload.translations_limit_per_cycle;
            state.marketplace_credits_used_in_cycle =
                action.payload.marketplace_credits_used_in_cycle;
            state.marketplace_credits_limit_per_cycle =
                action.payload.marketplace_credits_limit_per_cycle;
            state.image_generations_used_in_cycle = action.payload.image_generations_used_in_cycle;
            state.image_generations_limit_per_cycle =
                action.payload.image_generations_limit_per_cycle;
            state.addon_animation_minutes_quantity =
                action.payload.addon_animation_minutes_quantity;
        },
        updateImageGenerationsUsedInCycle: (state, action: PayloadAction<number>) => {
            state.image_generations_used_in_cycle = action.payload;
        },
        updateAnimationSecondsUsedInCycle: (state, action: PayloadAction<number>) => {
            state.animation_seconds_used_in_cycle = action.payload;
        },
        updateTrialAnimationSecondsUsed: (state, action: PayloadAction<number>) => {
            state.trial_animation_seconds_used = action.payload;
        },
    },
});

export const {
    setUsageLimit,
    updateImageGenerationsUsedInCycle,
    updateAnimationSecondsUsedInCycle,
    updateTrialAnimationSecondsUsed,
} = usageLimitSlice.actions;

export const usageLimitReducer = usageLimitSlice.reducer;

export type usageLimitState = ReturnType<typeof usageLimitReducer>;
